"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var LicenseDetails_1 = __importDefault(require("./LicenseDetails"));
var LicenseAntillephone = function (props) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setOpen = _a[1];
    var closeDetailsHandler = (0, react_1.useCallback)(function () {
        setOpen(false);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.icon, src: "/img/license.svg", alt: "license", onClick: function () {
                    setOpen(true);
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, (props === null || props === void 0 ? void 0 : props.licenseInfo)
                ? props.licenseInfo
                : t('licenseInfo', { website: (props === null || props === void 0 ? void 0 : props.website) || '' }))),
        isOpen && react_1.default.createElement(LicenseDetails_1.default, __assign({ onClose: closeDetailsHandler }, props))));
};
exports.default = LicenseAntillephone;
